import { render, staticRenderFns } from "./DemoBadgeShowOnHover.vue?vue&type=template&id=0d23cf50&"
import script from "./DemoBadgeShowOnHover.vue?vue&type=script&lang=js&"
export * from "./DemoBadgeShowOnHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VHover,VIcon})
